export default "__VITE_ASSET__BO$S4NPv__"